import { render, staticRenderFns } from "./ViolationStudent.vue?vue&type=template&id=c3115470&scoped=true&"
import script from "./ViolationStudent.vue?vue&type=script&lang=js&"
export * from "./ViolationStudent.vue?vue&type=script&lang=js&"
import style0 from "./ViolationStudent.vue?vue&type=style&index=0&id=c3115470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3115470",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VCol,VDatePicker,VMenu,VRow,VTextField,VTextarea})
